var map = {
	"./Base": 199,
	"./Base/": 199,
	"./Base/config": 843,
	"./Base/config.js": 843,
	"./Base/index": 199,
	"./Base/index.js": 199,
	"./Base/style": 171,
	"./Base/style.js": 171,
	"./Clutch": 491,
	"./Clutch/": 491,
	"./Clutch/index": 491,
	"./Clutch/index.js": 491,
	"./Clutch/style": 1136,
	"./Clutch/style.js": 1136,
	"./NewUi": 492,
	"./NewUi/": 492,
	"./NewUi/index": 492,
	"./NewUi/index.js": 492,
	"./NewUi/style": 1137,
	"./NewUi/style.js": 1137,
	"./OldUi": 493,
	"./OldUi/": 493,
	"./OldUi/index": 493,
	"./OldUi/index.js": 493,
	"./OldUi/style": 1138,
	"./OldUi/style.js": 1138,
	"./SpireonNew": 494,
	"./SpireonNew/": 494,
	"./SpireonNew/index": 494,
	"./SpireonNew/index.js": 494,
	"./SpireonNew/style": 1139,
	"./SpireonNew/style.js": 1139,
	"./SpireonOld": 495,
	"./SpireonOld/": 495,
	"./SpireonOld/index": 495,
	"./SpireonOld/index.js": 495,
	"./SpireonOld/style": 1140,
	"./SpireonOld/style.js": 1140
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1971;
module.exports = webpackAsyncContext;